import { Card, CardContent, Typography } from "@mui/material";
import React from "react";
import { BarChart, Bar, Tooltip, Legend, ResponsiveContainer } from "recharts";

interface PatientsChartProps {
  data?: Array<{
    ageGroup: string;
    male: number;
    female: number;
  }>;
  className?: string;
}

const PatientsChart: React.FC<PatientsChartProps> = ({
  data = [
    { ageGroup: "0-17", male: 15, female: 18 },
    { ageGroup: "18-24", male: 45, female: 30 },
    { ageGroup: "25-34", male: 35, female: 45 },
    { ageGroup: "35-44", male: 50, female: 35 },
    { ageGroup: "45-54", male: 40, female: 42 },
    { ageGroup: "55-64", male: 25, female: 35 },
    { ageGroup: "65+", male: 20, female: 22 },
  ],
  className = "",
}) => {
  return (
    <Card
      className={className}
      sx={{
        boxShadow: "none",
        border: "1px solid #d1d5db", // border-gray-300 equivalent
      }}
    >
      <CardContent>
        <Typography
          variant="h6"
          className="text-lg font-medium text-gray-600 mb-4"
        >
          Patients
        </Typography>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={data}
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          >
            <Tooltip />
            <Legend />
            <Bar dataKey="male" fill="#8884d8" name="Male" />
            <Bar dataKey="female" fill="#82ca9d" name="Female" />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default PatientsChart;
